import {
  getLocationDetails as _getLocationDetails,
  GetLocationDetailsPayload,
} from '@griply/services';
import { LocationDetails } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const getLocationDetails = async (
  payload: GetLocationDetailsPayload,
): Promise<LocationDetails> => {
  try {
    return await _getLocationDetails({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'locations-place-details' },
    });
    throw error;
  }
};
